(function () {
  /* ===========================================================
   * FREE GIFT for Stiletto v4.0.1 — add the free perfume when the
   * cart has 2+ qualifying items, remove it below 2. All AJAX, no reload.
   * Uses Stiletto's official cart events (AJAX / quick cart must be ON).
   * =========================================================== */

  const FREE_VARIANT_ID    = 47452761227429; // free perfume variant
  const PERFUME_PRODUCT_ID = 10468309794981; // perfume product (any variant)
  const THRESHOLD          = 2;              // qualifying items needed

  let updating = false;
  let debounce = null;

  /* 1) Lock the gift line with CSS so shoppers can't edit it.
   *    CSS survives every quick-cart re-render automatically — no JS needed.
   *    .quick-cart__item has data-id="{{ item.id }}" = the variant id. */
  (function lockGiftUI() {
    if (document.getElementById('free-gift-style')) return;
    const css = document.createElement('style');
    css.id = 'free-gift-style';
    css.textContent =
      `.quick-cart__item[data-id="${FREE_VARIANT_ID}"] .quantity-input,` +
      `.quick-cart__item[data-id="${FREE_VARIANT_ID}"] [data-remove-item]{display:none!important;}`;
    document.head.appendChild(css);
  })();

  /* 2) Change the gift qty, then tell Stiletto to rebuild the
   *    quick cart + header count. This is the official refresh hook. */
  async function setGift(quantity) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [FREE_VARIANT_ID]: quantity } })
    });
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
  }

  /* 3) Decide whether the gift belongs in the cart. */
  async function checkCart() {
    if (updating) return;
    updating = true;
    try {
      const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
      const gift = cart.items.find(i => i.variant_id === FREE_VARIANT_ID);

      let qualifying = 0;
      cart.items.forEach(i => {
        if (i.variant_id !== FREE_VARIANT_ID && i.product_id !== PERFUME_PRODUCT_ID) {
          qualifying += i.quantity;
        }
      });

      if (qualifying >= THRESHOLD && !gift)      await setGift(1); // add it
      else if (qualifying < THRESHOLD && gift)   await setGift(0); // remove it
      else if (gift && gift.quantity !== 1)      await setGift(1); // keep qty at 1
    } catch (e) {
      console.error('Free gift error:', e);
    } finally {
      updating = false;
    }
  }

  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(checkCart, 250); // coalesce bursts of events into one check
  }

  /* 4) Triggers — Stiletto fires these whenever the AJAX cart changes. */
  document.addEventListener('cart:item-added', schedule);
  document.addEventListener('cart:updated', schedule);

  /* First page load */
  if (document.readyState !== 'loading') checkCart();
  else document.addEventListener('DOMContentLoaded', checkCart);
})();